'use client'

import { type SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { storyblokEditable } from '@storyblok/react'
import { VINTAGE_SHOP_HERO_BLOCK } from '../vintageShop.constants'
import { VintageShopHero } from './VintageShopHero/VintageShopHero'

type HeroBlockContent = {
  heading?: string
  buttonLabel?: string
  backgroundImage?: boolean
}

type Props = SbBaseBlockProps<HeroBlockContent>

export function VintageShopHeroBlock({ blok }: Props) {
  return (
    <div {...storyblokEditable(blok)}>
      <VintageShopHero
        heading={blok.heading}
        buttonLabel={blok.buttonLabel}
        hasBackgroundImage={blok.backgroundImage}
      />
    </div>
  )
}

VintageShopHeroBlock.blockName = VINTAGE_SHOP_HERO_BLOCK
